import actions from './actions'

export default function InventorysReducer(
  state = {
    loading: false,
    editing: { inventoryID: 0, inventoryNumber: null },
  },
  action,
) {
  switch (action.type) {
    
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        // editing: null,
        saveSuccess: false,
      }

    case actions.ADD_LOCATION_RECIEVED:
      return {
        ...state,
        locationAdd: action.payload
      }

    case actions.ADD_LOCATION_RESET_RECIEVED:
      return {
        ...state,
        locationAdd: undefined
      }

    case actions.CONFIRM_MODAL_RESET_RECIEVER:
      return {
        ...state,
        confirm: undefined,
        confirmCatch: undefined,
      }

    case actions.CONFIRM_CHOOSE_OK_RECIEVER:
      return {
        ...state,
        confirmCatch: 1,
      }

    case actions.CONFIRM_MODAL_OPEN_RECIEVER:
      return {
        ...state,
        confirm: 1,
      }

    case actions.LIST_INVENTORY:
      return {
        ...state,
        // editing: { inventoryID: 0, inventoryNumber: null },
        result: action.result,
        loading: false,
        saveSuccess: false,
      }

    case actions.FETCH_MLFB_REQ:
      return {
        ...state,
        loading: true,
      }

    case actions.RESET_INVENTORY_REC:
      return {
        ...state,
        loading: false,
        editing: null
      }

    case actions.FETCH_MLFB_RECIEVED:
      return {
        ...state,
        loading: false,
        mlfb: action.result,
      }

    case actions.EDIT_INVENTORY:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
        openModal: action.openModal,
      }

    case actions.RESET_INVENTORY:
      return {
        ...state,
        editing: { inventoryID: 0, inventoryNumber: null },
        loading: false,
        saveSuccess: false,
        openModal: null,
      }

    case actions.NEW_INVENTORY:
      return {
        ...state,
        editing: { inventoryID: 0, inventoryNumber: null },
        loading: false,
        saveSuccess: false,
        openModal: true,
      }

    case actions.DELETE_INVENTORY_RECIEVED:
      return {
        ...state,
        editing: { inventoryID: 0 },
        loading: false,
        saveSuccess: true, // mark,
        openModal: null,
      }

    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }

    default:
      return state
  }
}
